import { render, staticRenderFns } from "./ArchiveDatatablePagination.vue?vue&type=template&id=7f79dc9c&"
import script from "./ArchiveDatatablePagination.vue?vue&type=script&lang=js&"
export * from "./ArchiveDatatablePagination.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveDatatablePagination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveDatatablePagination.vue"
export default component.exports